import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../atoms/Button'
import axios from 'axios'
import ErrorValidationMessage from '../../molecules/ErrorValidationMessage'
import { useQueryClient } from 'react-query'
const TwoFactorSettings = ({ user }) => {
  const [isEnabled, setIsEnabled] = useState(user.otp_enabled)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const queryClient = useQueryClient()

  const handleEnable = async () => {
    if (
      !window.confirm(
        '¿Estás seguro de habilitar la autenticación de dos pasos? Deberás configurarla en tu próximo inicio de sesión.'
      )
    )
      return

    setLoading(true)
    setError(null)
    try {
      await axios.put('/admin/v1/two_factor_auth.json', { otp_enabled: true })
      setIsEnabled(true)
      queryClient.invalidateQueries(['user', user.id])
    } catch (e) {
      setError('Error al habilitar la autenticación de dos pasos.')
    } finally {
      setLoading(false)
    }
  }

  const handleDisable = async () => {
    if (!window.confirm('¿Estás seguro de deshabilitar la autenticación de dos pasos?')) return

    setLoading(true)
    setError(null)
    try {
      await axios.delete('/admin/v1/two_factor_auth.json')
      setIsEnabled(false)
      queryClient.invalidateQueries(['user', user.id])
    } catch (e) {
      setError('Error al deshabilitar.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="py-6 md:py-8 px-6 md:px-8 bg-neutral-100 mb-4">
      <h2 className="mb-4 font-bold text-xl">Seguridad</h2>
      <div className="py-6 md:py-8 px-6 md:px-8 bg-white">
        <h3 className="font-bold text-lg mb-2">Autenticación de dos pasos (2FA)</h3>
        <p className="mb-4 text-gray-600">
          Protege tu cuenta con una capa adicional de seguridad. Al iniciar sesión, se te pedirá un código de
          verificación.
        </p>

        {error && <ErrorValidationMessage error={error} className="mb-4" />}

        {isEnabled ? (
          <div>
            <div className="flex items-center text-green-600 mb-4 font-bold">
              <span className="mr-2">✓</span> Habilitado
            </div>
            <Button variant="secondary" onClick={handleDisable} disabled={loading}>
              Deshabilitar 2FA
            </Button>
          </div>
        ) : (
          <div>
            <Button onClick={handleEnable} disabled={loading}>
              Habilitar 2FA
            </Button>
            <p className="text-sm text-gray-500 mt-2">
              Al habilitar esta opción, el usuario deberá configurar su aplicación de autenticación en el próximo inicio
              de sesión.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

TwoFactorSettings.propTypes = {
  user: PropTypes.object.isRequired
}

export default TwoFactorSettings
